import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SpinnerButtonComponent} from './spinner-button.component';
import {MatButtonModule} from '@angular/material/button';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {ButtonModule, LoadingSpinnerModule} from '@ucx/ui-cmp';
import {SpinnerModule} from '../spinner/spinner.module';


@NgModule({
  declarations: [SpinnerButtonComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    ButtonModule,
    SpinnerModule,
    LoadingSpinnerModule
  ],
  exports: [
    SpinnerButtonComponent
  ]
})
export class SpinnerButtonModule {
}
